import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{html-safe this.structuredData}}\n",{ moduleName: "client-portal/components/practice-website/seo-structured-data.hbs" })